import type IGameSettings from '../../../../../types/models/IGameSettings';
import { GAME_FEATURES } from '@repo/common';

// Game features that display as a text label in the jackpot band instead of a jackpot value/currency,
// games with no real jackpotName that still need jackpot-band styling/positioning.
// Add more GAME_FEATURES entries here as new exceptions are needed.
const NO_JACKPOT_EXCEPTION_FEATURES: string[] = [GAME_FEATURES.HIGH_RTP];

export const getNoJackpotException = (gameFeatures: IGameSettings['gameFeatures']): string | null =>
  NO_JACKPOT_EXCEPTION_FEATURES.find((feature) => gameFeatures?.includes(feature)) ?? null;

export const getJackpotSlug = (label?: string | null): string =>
  (label ?? '').split(' ').join('_').toLowerCase();
